// import React, { useEffect, useState } from "react";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const Transactions = () => {
//   const [data, setData] = useState([]);
  
//   const user = JSON.parse(localStorage.getItem("user"));

//   const fetchPendingProcurements = async () => {
//     try {
//       const res = await fetch(`${process.env.REACT_APP_BASE_URL}procurement/pending`, {
//         headers: {
//           Authorization: `Bearer ${user?.token}`,
//         },
//       });
//       const json = await res.json();
//       setData(json?.data || []);
//     } catch (err) {
//       console.error("Error fetching pending procurements", err);
//     }
//   };

//   useEffect(() => {
//     fetchPendingProcurements();
//   }, []);

//   const exportToExcel = () => {
//     const exportData = data.map((item) => ({
//       State: `${item.statename} (${item.statecode})`,
//       "Commodity Code": item.commoditycode,
//       Scheme: item.scheme,
//       "Sanction Qty": item.sanctionqty,
//       "Progressive Procurement": item.progressiveprocurement,
//       MSP: item.msp,
//       "Payment Amount": item.paymentamount,
//       "Farmers Benefitted": item.prognooffarmersbenefitted,
//       "Start Date": new Date(item.procstartdate).toLocaleDateString(),
//       "End Date": new Date(item.procenddate).toLocaleDateString(),
//     }));

//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Pending Procurements");

//     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
//     saveAs(blob, "Pending_Procurements.xlsx");
//   };


//   return (
//     <div className="bg-white shadow-md rounded p-6 overflow-x-auto mt-4">
//       <h2 className="text-2xl font-bold mb-4 text-gray-800">Pending Procurements</h2>
//       <div className="flex justify-end mb-4">
//   <button
//     onClick={exportToExcel}
//     className="bg-green-600 hover:bg-green-700 text-white font-medium px-4 py-2 rounded shadow"
//   >
//     Export to Excel
//   </button>
// </div>
//       <table className="min-w-full divide-y divide-gray-200 text-sm">
//         <thead className="bg-gray-100">
//           <tr>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">State</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Commodity Code</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Scheme</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Sanction Qty</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Progressive Procurement</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">MSP</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Amount Paid</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Beneficiaries</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Start Date</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">End Date</th>
//           </tr>
//         </thead>
//         <tbody className="divide-y divide-gray-100">
//           {data.map((item, index) => (
//             <tr key={index} className="hover:bg-gray-50">
//               <td className="px-4 py-2">{item.statename} ({item.statecode})</td>
//               <td className="px-4 py-2">{item.commoditycode}</td>
//               <td className="px-4 py-2">{item.scheme}</td>
//               <td className="px-4 py-2">{item.sanctionqty?.toLocaleString()} {item.uom_of_qty}</td>
//               <td className="px-4 py-2">{item.progressiveprocurement?.toLocaleString()} {item.uom_of_qty}</td>
//               <td className="px-4 py-2">₹ {parseFloat(item.msp).toLocaleString()}</td>
//               <td className="px-4 py-2">₹ {parseFloat(item.paymentamount).toLocaleString()}</td>
//               <td className="px-4 py-2">{item.prognooffarmersbenefitted}</td>
//               <td className="px-4 py-2">{new Date(item.procstartdate).toLocaleDateString()}</td>
//               <td className="px-4 py-2">{new Date(item.procenddate).toLocaleDateString()}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {data.length === 0 && (
//         <p className="text-center text-gray-500 py-4">No pending procurements found.</p>
//       )}
//     </div>
//   );
// };

// export default Transactions;
// import React, { useEffect, useState } from "react";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const Transactions = () => {
//   const [data, setData] = useState([]);
//   const [selectedIds, setSelectedIds] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);

//   const user = JSON.parse(localStorage.getItem("user"));

//   const fetchPendingProcurements = async () => {
//     try {
//       const res = await fetch(`${process.env.REACT_APP_BASE_URL}procurement/pending`, {
//         headers: {
//           Authorization: `Bearer ${user?.token}`,
//         },
//       });
//       const json = await res.json();
//       setData(json?.data || []);
//     } catch (err) {
//       console.error("Error fetching pending procurements", err);
//     }
//   };

//   useEffect(() => {
//     fetchPendingProcurements();
//   }, []);

//   const exportToExcel = () => {
//     const exportData = data.map((item) => ({
//       State: `${item.statename} (${item.statecode})`,
//       "Commodity Code": item.commoditycode,
//       Scheme: item.scheme,
//       "Year":item.year,
//       "Season":item.season,
//       "Sanction Qty": item.sanctionqty,
//       "Progressive Procurement": item.progressiveprocurement,
//       MSP: item.msp,
//       "Payment Amount": item.paymentamount,
//       "Farmers Benefitted": item.prognooffarmersbenefitted,
//       "Start Date": new Date(item.procstartdate).toLocaleDateString(),
//       "End Date": new Date(item.procenddate).toLocaleDateString(),
//     }));

//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Pending Procurements");

//     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
//     saveAs(blob, "Pending_Procurements.xlsx");
//   };

//   const handleSelectAll = () => {
//     if (selectAll) {
//       setSelectedIds([]);
//     } else {
//       setSelectedIds(data.map((item) => item.id));
//     }
//     setSelectAll(!selectAll);
//   };

//   const handleCheckboxChange = (id) => {
//     if (selectedIds.includes(id)) {
//       setSelectedIds((prev) => prev.filter((i) => i !== id));
//     } else {
//       setSelectedIds((prev) => [...prev, id]);
//     }
//   };

//   const handleApprove = async () => {
//     try {
//       const res = await fetch(`${process.env.REACT_APP_BASE_URL}procurement/update-status`, {
//         method: "PATCH",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${user?.token}`,
//         },
//         body: JSON.stringify({
//           ids: selectedIds,
//           status: "Approved",
//         }),
//       });

//       const json = await res.json();
//       if (json.message === "Procurement status updated successfully") {
//         const remaining = data.filter((item) => !selectedIds.includes(item.id));
//         setData(remaining);
//         setSelectedIds([]);
//         setSelectAll(false);
//       }
//     } catch (err) {
//       console.error("Error approving procurements", err);
//     }
//   };

//   return (
//     <div className="bg-white shadow-md rounded p-6 overflow-x-auto mt-4">
//       <div className="flex justify-between items-center mb-4">
//         <h2 className="text-2xl font-bold text-gray-800">Pending Procurements</h2>
//         <div className="flex gap-4">
//           <button
//             onClick={exportToExcel}
//             className="bg-green-600 hover:bg-green-700 text-white font-medium px-4 py-2 rounded shadow"
//           >
//             Export to Excel
//           </button>
//           <button
//             disabled={selectedIds.length === 0}
//             onClick={handleApprove}
//             className={`${
//               selectedIds.length === 0
//                 ? "bg-gray-300 cursor-not-allowed"
//                 : "bg-blue-600 hover:bg-blue-700"
//             } text-white font-medium px-4 py-2 rounded shadow`}
//           >
//             Approve Selected
//           </button>
//         </div>
//       </div>

//       <table className="min-w-full divide-y divide-gray-200 text-sm">
//         <thead className="bg-gray-100">
//           <tr>
//             <th className="px-2 py-2 text-left">
//               <input
//                 type="checkbox"
//                 checked={selectAll}
//                 onChange={handleSelectAll}
//               />
//             </th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">State</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Commodity</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Scheme</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Year</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Season</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Sanction Qty(QTL)</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Progressive Procurement(QTL)</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">MSP</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Amount Paid</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Farmers Benefitted</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Start Date</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">End Date</th>
//           </tr>
//         </thead>
//         <tbody className="divide-y divide-gray-100">
//           {data.map((item) => (
//             <tr key={item.id} className="hover:bg-gray-50">
//               <td className="px-2 py-2">
//                 <input
//                   type="checkbox"
//                   checked={selectedIds.includes(item.id)}
//                   onChange={() => handleCheckboxChange(item.id)}
//                 />
//               </td>
//               <td className="px-4 py-2">{item.statename} ({item.statecode})</td>
//               <td className="px-4 py-2">{item.commodityname}</td>
//               <td className="px-4 py-2">{item.scheme}</td>
//                <td className="px-4 py-2">{item.year}</td>
//                 <td className="px-4 py-2">{item.season}</td>
//               <td className="px-4 py-2">{item.sanctionqty?.toLocaleString()}</td>
//               <td className="px-4 py-2">{item.progressiveprocurement?.toLocaleString()}</td>
//               <td className="px-4 py-2">₹ {parseFloat(item.msp).toLocaleString()}</td>
//               <td className="px-4 py-2">₹ {parseFloat(item.paymentamount).toLocaleString()}</td>
//               <td className="px-4 py-2">{item.prognooffarmersbenefitted}</td>
//               <td className="px-4 py-2">{new Date(item.procstartdate).toLocaleDateString()}</td>
//               <td className="px-4 py-2">{new Date(item.procenddate).toLocaleDateString()}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {data.length === 0 && (
//         <p className="text-center text-gray-500 py-4">No pending procurements found.</p>
//       )}
//     </div>
//   );
// };

// export default Transactions;
import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Transactions = () => {
  const [data, setData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [years, setYears] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [states, setStates] = useState([]);
  const [commodities, setCommodities] = useState([]);

  const [selectedYear, setSelectedYear] = useState("");
  const [selectedSeason, setSelectedSeason] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCommodity, setSelectedCommodity] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const buildQuery = () => {
    const params = new URLSearchParams();
    if (selectedYear) params.append("year", selectedYear);
    if (selectedSeason) params.append("season", selectedSeason);
    if (selectedCommodity) params.append("commoditycode", selectedCommodity);
    if (selectedState) params.append("state", selectedState);
    return params.toString();
  };

  const fetchFilters = async () => {
    try {
      const [yRes, sRes, stRes, cRes] = await Promise.all([
        fetch(`${baseUrl}common/years`, { headers: { Authorization: `Bearer ${user.token}` } }),
        fetch(`${baseUrl}common/seasons`, { headers: { Authorization: `Bearer ${user.token}` } }),
        fetch(`${baseUrl}common/states`, { headers: { Authorization: `Bearer ${user.token}` } }),
        fetch(`${baseUrl}commodity`, { headers: { Authorization: `Bearer ${user.token}` } }),
      ]);
      const yj = await yRes.json();
      const sj = await sRes.json();
      const stj = await stRes.json();
      const cj = await cRes.json();

      setYears(Array.isArray(yj) ? yj : []);
      setSeasons(Array.isArray(sj)
        ? sj.map(s => ({ key: s.key, value: s.value.charAt(0).toUpperCase() + s.value.slice(1).toLowerCase() }))
        : []);
      setStates(Array.isArray(stj) ? stj : []);
      setCommodities(Array.isArray(cj) ? cj : []);
    } catch (e) {
      console.error("Error loading filters", e);
    }
  };

  const fetchData = async () => {
    try {
      const qs = buildQuery();
      const res = await fetch(`${baseUrl}procurement/pending?${qs}`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
      const json = await res.json();
      setData(json.data || []);
      setSelectedIds([]);
      setSelectAll(false);
    } catch (e) {
      console.error("Error loading data", e);
    }
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  useEffect(() => {
    fetchData();
  }, [selectedYear, selectedSeason, selectedState, selectedCommodity]);

  const exportToExcel = () => {
    const sheetData = data.map(item => ({
      State: `${item.statename} (${item.statecode})`,
      "Commodity Name": item.commodityname,
      Scheme: item.scheme,
      Year: item.year,
      Season: item.season,
      "Sanction Qty": item.sanctionqty,
      "Progressive Procurement": item.progressiveprocurement,
      MSP: item.msp,
      "Payment Amount": item.paymentamount,
      "Farmers Benefitted": item.prognooffarmersbenefitted,
      "Start Date": new Date(item.procstartdate).toLocaleDateString(),
      "End Date": new Date(item.procenddate).toLocaleDateString(),
    }));
    const ws = XLSX.utils.json_to_sheet(sheetData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Pending Procurements");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([buf], { type: "application/octet-stream" }), "Pending_Procurements.xlsx");
  };

  const handleSelectAll = () => {
    setSelectedIds(selectAll ? [] : data.map(d => d.id));
    setSelectAll(!selectAll);
  };
  const toggleId = (id) =>
    setSelectedIds(prev => (prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]));

  const handleApprove = async () => {
    try {
      const res = await fetch(`${baseUrl}procurement/update-status`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${user.token}` },
        body: JSON.stringify({ ids: selectedIds, status: "Approved" }),
      });
      const { message } = await res.json();
      if (message === "Procurement status updated successfully") {
        setData(prev => prev.filter(i => !selectedIds.includes(i.id)));
        setSelectedIds([]);
        setSelectAll(false);
      }
    } catch (e) {
      console.error("Error approving", e);
    }
  };

  return (
    <div className="bg-white shadow rounded p-6 overflow-x-auto mt-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Pending Procurements</h2>
        <div className="flex gap-4">
          <button onClick={exportToExcel} className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded">
            Export to Excel
          </button>
          <button
            disabled={!selectedIds.length}
            onClick={handleApprove}
            className={`text-white px-4 py-2 rounded ${
              selectedIds.length ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-300 cursor-not-allowed"
            }`}
          >
            Approve Selected
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="flex flex-wrap gap-4 mb-5">
        {[
          { label: "Year", options: years, value: selectedYear, set: setSelectedYear, keyProp: "year" },
          { label: "Season", options: seasons, value: selectedSeason, set: setSelectedSeason, keyProp: "key", displayProp: "value" },
          { label: "Commodity", options: commodities, value: selectedCommodity, set: setSelectedCommodity, keyProp: "commoditycode", displayProp: "commodityname" },
          { label: "State", options: states, value: selectedState, set: setSelectedState, keyProp: "code", displayProp: "name" },
        ].map(({ label, options, value, set, keyProp, displayProp }) => (
          <div key={label}>
            <label className="block text-sm font-medium text-gray-600">{label}</label>
            <select
              value={value}
              onChange={e => set(e.target.value)}
              className="border border-gray-300 rounded px-3 py-1"
            >
              <option value="">All</option>
              {options.map(opt => (
                <option key={opt[keyProp]} value={opt[keyProp]}>
                  {displayProp ? opt[displayProp] : opt[keyProp]}
                </option>
              ))}
            </select>
          </div>
        ))}
      </div>

      <table className="min-w-full divide-y divide-gray-200 text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-2 py-2">
              <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
            </th>
            {["State", "Commodity", "Scheme", "Year", "Season", "Sanction Qty(QTL)", "Progressive Procurement(QTL)", "MSP", "Amount Paid", "Farmers Benefitted", "Start Date", "End Date"].map(h => (
              <th key={h} className="px-4 py-2 font-medium text-gray-600 text-left">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {data.map(item => (
            <tr key={item.id} className="hover:bg-gray-50">
              <td className="px-2 py-2">
                <input
                  type="checkbox"
                  checked={selectedIds.includes(item.id)}
                  onChange={() => toggleId(item.id)}
                />
              </td>
              <td className="px-4 py-2">{item.statename} ({item.statecode})</td>
              <td className="px-4 py-2">{item.commodityname}</td>
              <td className="px-4 py-2">{item.scheme}</td>
              <td className="px-4 py-2">{item.year}</td>
              <td className="px-4 py-2">{item.season}</td>
              <td className="px-4 py-2">{item.sanctionqty?.toLocaleString()}</td>
              <td className="px-4 py-2">{item.progressiveprocurement?.toLocaleString()}</td>
              <td className="px-4 py-2">₹ {parseFloat(item.msp).toLocaleString()}</td>
              <td className="px-4 py-2">₹ {parseFloat(item.paymentamount).toLocaleString()}</td>
              <td className="px-4 py-2">{item.prognooffarmersbenefitted}</td>
              <td className="px-4 py-2">{new Date(item.procstartdate).toLocaleDateString()}</td>
              <td className="px-4 py-2">{new Date(item.procenddate).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {!data.length && <p className="text-center text-gray-500 py-4">No pending procurements found.</p>}
    </div>
  );
};

export default Transactions;
